import * as http from '../helpers/http';

class ParlamentarDemandaService {

    GetList = async (id: number, filtro: any, pageIndex: number, pageSize: number = 8): Promise<any> => {

        const result = await http.get(`/parlamentar/${id}/demandas?filter=${JSON.stringify(filtro)}&pageSize=${pageSize}&pageIndex=${pageIndex}`);
        if (result.success) {
            return {
                success: true,
                listInfo: {
                    pageSize: result.data.pageSize,
                    pageIndex: result.data.pageIndex,
                    pageItens: result.data.pageItens,
                    totalItens: result.data.totalItens,
                    totalPages: result.data.totalPages,
                    totalNoFilter: result.data.totalNoFilter
                },
                lista: result.data.data
            }
        }
        return undefined;
    }

    GetSummary = async (id: number): Promise<any> => {
        const result = await http.get(`/parlamentar/${id}/demandas/summary`);
        if (result.success) {
            return result.data;
        }
        return undefined;
    }

    Create = async (data: any, id: number): Promise<any> => {
        const result = await http.post(`/parlamentar/${id}/demandas`, data);
        if (result.success) { return result.data }
        return 0;
    }
    Get = async (id: number): Promise<any> => {
        const result = await http.get(`/parlamentar/demandas/${id}`);
        if (result.success) { return result }
        return undefined;
    };

    Update = async (data: any, id: number,): Promise<boolean> => {
        const result = await http.put(`/parlamentar/demandas/${id}`, data);
        if (result.success) { return result.success }
        return false;
    };

    Delete = async (id: number): Promise<boolean> => {
        const result = await http.del(`/parlamentar/demandas/${id}`);
        if (result.success) { return true }
        return false;
    };
}


export default new ParlamentarDemandaService();
